import { TFunction } from 'i18next';
export type TranslateFunction = (key: string, params?: Record<string, any>) => string;

const useTranslate = (t: TFunction<string>): { translate: TranslateFunction } => {
    const translate: TranslateFunction = (key: string, params?: Record<string, any>): string =>
        String(t(key, { ...(params || {}), defaultValue: key }));

    return { translate };
};

export default useTranslate;
